import { Amplify } from 'aws-amplify';
import { getCurrentUser, fetchAuthSession, signInWithRedirect, signOut as amplifySignOut, fetchUserAttributes, signIn, resetPassword, confirmResetPassword, confirmSignIn, updateUserAttribute } from 'aws-amplify/auth';
import { COGNITO_CONFIG } from '../utils/authConfig';

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: COGNITO_CONFIG.userPoolId,
            userPoolClientId: COGNITO_CONFIG.clientId,
            loginWith: {
                oauth: {
                    domain: COGNITO_CONFIG.domain,
                    scopes: ['openid', 'email', 'phone'],
                    redirectSignIn: [COGNITO_CONFIG.redirectUri],
                    redirectSignOut: [COGNITO_CONFIG.redirectUri],
                    responseType: 'code',
                },
            },
        },
    },
});

export const login = () => signInWithRedirect();
export const loginDirect = (username, password) => signIn({ username, password });
export const handleResetPassword = (username) => resetPassword({ username });
export const handleConfirmResetPassword = (username, confirmationCode, newPassword) => confirmResetPassword({ username, confirmationCode, newPassword });
export const handleConfirmSignIn = (challengeResponse) => confirmSignIn({ challengeResponse });
export const handleUpdateUserAttribute = (attributeKey, value) => updateUserAttribute({ userAttribute: { attributeKey, value } });
export const logout = () => amplifySignOut();
export const getUser = async () => {
    try {
        const user = await getCurrentUser();
        const session = await fetchAuthSession();

        let attributes = {};
        try {
            attributes = await fetchUserAttributes();
        } catch (e) {
            console.warn("Failed to fetch user attributes", e);
        }

        return {
            user: { ...user, ...attributes },
            token: session.tokens?.accessToken?.toString(),
            idToken: session.tokens?.idToken?.toString()
        };
    } catch (e) {
        return null;
    }
};
